import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import Modal from "react-bootstrap/Modal";
import {BDSMForm} from "../../../../components/form/BDSMForm";
import * as Yup from "yup";
import {CreateButton} from "../../../../components/buttons/CreateButton";
import { minStringLength } from '../../../../validations/Validators';
import { getAllProductsList } from '../product/ProductService';

export const PartnerForm = ({onClick, onCancel, editingPartner}) => {

    const {t} = useTranslation('partner');
    const [show, setShow] = useState(false);
    const [products, setProducts] = useState([]);
    const handleClose = () => setShow(false);
    let isEditing = editingPartner.id;

    const validation = Yup.object().shape({
        partnerName: minStringLength(3, t).required(t('validations:required')),
        address: minStringLength(5, t).required(t('validations:required')),
        companyCode: Yup.string().required(t('validations:required')),
        pvmCode: Yup.string(),
        phoneNumber: Yup.string(),
        email: Yup.string()
    });

    const handleShow = () => {
        if (products.length === 0) {
            getAllProductsList()
                .then((response) => setProducts(
                    response.data.map(it => ({ name: it.title, value: it.id })),
                ))
                .catch(() => alert.error(t('alert:loadingError')));
        }
        setShow(true);
    }

    const handleSubmit = (values) => {
        let mappedProducts = values.products.map(it => ({id: it.value, title: it.label}))
        let result = {
            ...values,
            products: mappedProducts
        }
        onClick(result, editingPartner.id);
        onClose();
    };

    const onClose = () => {
        onCancel()
        handleClose()
    }

    const getFormModel = () => {
        return {
            initValues: isEditing ?
                {
                    partnerName: editingPartner.partnerName,
                    address: editingPartner.address,
                    companyCode: editingPartner.companyCode,
                    pvmCode: editingPartner.pvmCode,
                    phoneNumber: editingPartner.phoneNumber,
                    email: editingPartner.email,
                    products: editingPartner.products
                }
                :
                {
                    partnerName: '',
                    address: '',
                    companyCode: '',
                    pvmCode: '',
                    phoneNumber: '',
                    email: '',
                    products: []
                },
            onSubmit: (record) => handleSubmit(record),
            onCancel: () => onClose(),
            validationSchema: validation,
            fieldNames: ['partnerName', 'address', 'companyCode', 'pvmCode', 'phoneNumber', 'email', 'products'],
            types: ['text', 'text', 'text', 'text', 'text', 'text', 'searchMultiSelect'],
            className: 'mb-3',
            label: [
                t('partnerName'),
                t('address'),
                t('companyCode'),
                t('pvmCode'),
                t('phoneNumber'),
                t('email'),
                t('products')
            ],
            selectData: [null, null, null, null, null, null, products],
            inputFieldsClass: ''
        }
    }

    return (
        <>
            <CreateButton onClick={handleShow}/>
            <Modal show={show} onHide={onClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{isEditing ? t('updatePartner') : t('newPartner')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BDSMForm form={getFormModel()}/>
                </Modal.Body>
            </Modal>
        </>
    )
}